export default __webpack_public_path__ + "static/media/6N5A3876.15fc696f.jpg";